export function getMaskedCnpj (unmaskedCnpj) {
    return getValidStringInput(unmaskedCnpj).toUpperCase().replace(
        /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
    );
}

export function getUnmaskedCnpj (maskedCnpj) {
    return getValidStringInput(maskedCnpj).replace(/[.\/-]/g, '').toUpperCase();
}

function getValidStringInput (input) {
    if (input === undefined || input === null) {
        return '';
    }

    return String(input);
}
